
import style from './index.less'
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Modal,
  Select,
  Cascader,
  Input
} from 'antd';
import AsyncAppHOCFN from "../AsyncAppHOC";
import IntlWrap from "../intlWrap";
const {Option} = Select;
class Cascader_Address extends Component {
  static contextTypes = {
    isMobile: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      saveCountryList: [],
      saveDistrictyList: [],
      visible: false,
      // fitleinputFoucus: false,
      SelectFitleV: '',
      options: [],
      topOptions:[],
      orgaddressk: '',
      countryCode: '',
      provinceCode: '',
      cityCode: '',
      districtCode: '',
      orgAddress: '',
      provinceText:'',
      cityText:'',
      districtText:'',
      showCascader_Address:false,
      isowner:props.isowner||false,
      isfirst:true
    }
  }
  componentWillReceiveProps(nextProps) {

    let {getDate}=this.props;
    let orgaddressk=[];
    // if(!isowner){
    if ('countrycode' in nextProps) {
      let value = nextProps.countrycode;
      let {countrycode,locale}=this.props;
      if(countrycode!=value){
        this.setState({
          toPcountryCode: value ,
          countryCode: value ,
        });
          getDate(
              {
                  name:'getDistrictyList',
                  url:'http://192.168.3.80:10208/api/108103101',
                  params:{countryId: value||'CN'},
                  locale
              },
              ()=>{
                  let {getDistrictyList,getCountryList}=this.props;
                  let saveDistrictyList=getDistrictyList&&getDistrictyList.posts&&getDistrictyList.posts.json&&getDistrictyList.posts.json.json||[]
                  let saveCountryList=getCountryList&&getCountryList.posts&&getCountryList.posts.json&&getCountryList.posts.json.rows||[]
                  let options=this.changeDistrictyList(saveDistrictyList);
                  let countryDate=this.getCountryDate(value||'CN',saveCountryList);
                  let topCountryText=countryDate&&countryDate.countryName;

                  this.setState({
                      options,
                      topOptions:[{value:value||'CN',label:topCountryText,children:[...options]}]
                  })
          }
          )
      }
    }
    if ('orgAddress' in nextProps) {
      let value = nextProps.orgAddress;
      let nowValue=this.props.orgAddress;
      if(value!=nowValue){
        this.setState({
          toPorgAddress: value || "",
          orgAddress: value || "",
        })
      }
    }
    if ('provinceText' in nextProps) {
      let value = nextProps.provinceText;
      let nowValue=this.props.provinceText;
      if(value!=nowValue){
        this.setState({
          toPprovinceText: value || "",
          provinceText: value || "",
        })
      }
    }
    if ('cityText' in nextProps) {
      let value = nextProps.cityText;
      let nowValue=this.props.cityText;
      if(value!=nowValue){
        this.setState({
          toPcityText: value || "",
          cityText: value || "",
        })
      }
    }
    if ('districtText' in nextProps) {
      let value = nextProps.districtText;
      let nowValue=this.props.districtText;
      if(value!=nowValue){
        this.setState({
          toPdistrictText: value || "",
          districtText: value || "",
        })
      }
    }
    if ('provincecode' in nextProps) {
      let value = nextProps.provincecode;
      let nowValue=this.props.provincecode;
      if(value!=nowValue){
        this.setState({
          toPprovinceCode: value || "",
          provinceCode: value || "",
        })

      }
      orgaddressk[0] = value ? value + '' : ''
    }
    if ('citycode' in nextProps) {
      let value= nextProps.citycode;
      let nowValue=this.props.cityCode;
      if(value!=nowValue){
        this.setState({
          toPcityCode: value || "",
          cityCode: value || "",
        })
        orgaddressk[1] = value ? value + '' : ''
      }
      orgaddressk[1] = value ? value + '' : ''

    }
    if ('districtcode' in nextProps) {
      let value = nextProps.districtcode;
      let nowValue=this.props.districtcode;
      if(value!=nowValue){
        this.setState({
          toPstrictcode: value || "",

          districtcode: value || "",
        })
      }
      orgaddressk[2] = value ? value + '' : ''
    }
    let topOrgaddressk=[]
    let orgaddresskN=[]
    if(orgaddressk[0]){
      orgaddresskN[0]=orgaddressk[0];
      if(orgaddressk[1]){
        orgaddresskN[1]=orgaddressk[1];
        if(orgaddressk[2]){
          orgaddresskN[2]=orgaddressk[2]
        }
      }
    }

    if( nextProps.countrycode){
      topOrgaddressk=[nextProps.countrycode,...orgaddresskN]
    }
    this.setState({
      orgaddressk:orgaddresskN,
      topOrgaddressk
    })
  }

  componentDidMount() {

    let {getDate,countrycode,locale}=this.props;
    //109103101
      getDate(
          {
              name:'getCountryList',
              url:'http://192.168.3.80:10208/api/108104101',
              locale
          },
          ()=>{
              getDate(
                  {
                      name:'getDistrictyList',
                      url:'http://192.168.3.80:10208/api/108103101',
                      params:{countryId: countrycode||'CN'},
                      locale
                  },
                  ()=>{
                      let {getDistrictyList,getCountryList}=this.props;
                      let saveDistrictyList=getDistrictyList&&getDistrictyList.posts&&getDistrictyList.posts.json&&getDistrictyList.posts.json.json||[]
                      let saveCountryList=getCountryList&&getCountryList.posts&&getCountryList.posts.json&&getCountryList.posts.json.rows||[]
                      let options=this.changeDistrictyList(saveDistrictyList);
                      let countryDate=this.getCountryDate(countrycode||'CN',saveCountryList);
                      let topCountryText=countryDate&&countryDate.countryName;
                      this.setState({
                          options,
                          topOptions:[{value:countrycode||'CN',label:topCountryText,children:[...options]}]
                      })
                  }
                  )

          }
      )
    // this.showModal(true)
    // dispatch({
    //   type: 'global/getCountryList',
    //   payload: {}
    // }).then(()=>{
    //   dispatch({
    //     type: 'global/getDistrictyList',
    //     payload: {countryId: countrycode||'CN'}
    //   }).then(()=>{
    //     let {saveDistrictyList,saveCountryList}=this.props;
    //     let options=this.changeDistrictyList(saveDistrictyList);
    //     let countryDate=this.getCountryDate(countrycode||'CN',saveCountryList);
    //     let topCountryText=countryDate&&countryDate.countryName;
    //     this.setState({
    //       options,
    //       topOptions:[{value:countrycode||'CN',label:topCountryText,children:[...options]}]
    //     })
    //   })
    // })


  }
  showModal = (isprevent,isclick) => {
    let {dispatch,disabled,getDate,locale}=this.props;
    if(disabled){
      return
    }
    let {topOrgaddressk=[],toPcountryCode,toPprovinceCode,toPstrictcode,toPcityCode}=this.state;
    this.setState({
      visible:true,
      orgaddressk:topOrgaddressk.slice(1),
      countryCode:toPcountryCode
    });
      getDate(
          {
              name:'getDistrictyList',
              url:'http://192.168.3.80:10208/api/108103101',
              params:{countryId: toPcountryCode||'CN'},
              locale
          },
          ()=>{
              let {getDistrictyList}=this.props;
              let saveDistrictyList=getDistrictyList&&getDistrictyList.posts&&getDistrictyList.posts.json&&getDistrictyList.posts.json.json||[]

                let options=this.changeDistrictyList(saveDistrictyList);
                let orgaddressk=[];
                if(toPprovinceCode){
                  orgaddressk[0]=toPprovinceCode;
                  if(toPcityCode){
                    orgaddressk[1]=toPcityCode;
                    if(toPstrictcode){
                      orgaddressk[2]=toPstrictcode
                    }
                  }
                }

              this.setState({
                  options,
                  orgaddressk:orgaddressk,
                })
          }
      )
    // dispatch({
    //   type: 'global/getDistrictyList',
    //   payload: {countryId: toPcountryCode||'CN'}
    // }).then(()=>{
    //   let {saveDistrictyList}=this.props;
    //   let options=this.changeDistrictyList(saveDistrictyList);
    //   let orgaddressk=[];
    //   if(toPprovinceCode){
    //     orgaddressk[0]=toPprovinceCode;
    //     if(toPcityCode){
    //       orgaddressk[1]=toPcityCode;
    //       if(toPstrictcode){
    //         orgaddressk[2]=toPstrictcode
    //       }
    //     }
    //   }
    //   this.setState({
    //     options,
    //     orgaddressk:orgaddressk,
    //   })
    // })

  };
  handleOk = (e) => {

    let {onChange,saveDistrictyList,saveCountryList}=this.props;
    let {countryCode,countryText,orgaddressk,options}=this.state;
    this.setState({
      visible:false,
      topCountryText:countryText,
      topCountryCode:countryCode,
      topOrgaddressk:[countryCode,...orgaddressk],
      topOptions:[{value:countryCode||'CN',label:countryText,children:[...options]}]

    },()=>{

      if(onChange&&typeof onChange=='function'){
        let {countryText, countryCode, provinceCode, cityCode, districtCode,provinceText,cityText,districtText, orgAddress} = this.state;
        onChange({
          countryText, countryCode, provinceCode: provinceCode + '', cityCode: cityCode + '', districtCode: districtCode + '', orgAddress,provinceText,cityText,districtText
        })
      }
    });

    // this.showModal(true)
    // if(changeVisib&&typeof changeVisib=='function'){
    //   changeVisib(false)
    // }

  };
  handleCancel = (e) => {

    this.setState({
      visible:false,
    });
  };
  clearDate = (e) => {

    let {
      countryText
    }=this.state;
    e&&e.stopPropagation();

    this.setState({
      orgaddressk:[],
      provinceCode:'', cityCode:'', districtCode:'',provinceText:'',cityText:'',districtText:'', orgAddress:countryText
    })

  };
  clearDateTop=()=>{
    let {onChange}=this.props;
    if(onChange&&typeof onChange=='function'){
      onChange({
        countryText:"", countryCode:'', provinceCode:'', cityCode: '', districtCode:'', orgAddress:'',provinceText:'',cityText:'',districtText:''
      })
    }
  }
  getCountryDate=(k,saveCountryList=[])=>{
    for(let i=0;i<saveCountryList.length;i++){
      let countryDate=saveCountryList[i];
      if(countryDate.countryId==k){
        return countryDate
      }
    }
    return null
  }
  // setCountryText=(k='CN')=>{
  //
  //   let {saveCountryList} = this.props;
  //   saveCountryList.map((r)=>{
  //     if(r.countryId==k){
  //       let selectedLang = getLocale();
  //       this.setState({
  //         countryText:selectedLang && selectedLang == 'en-US' ? r.countryEname :r.countryName
  //       })
  //
  //       this.setState({
  //         topCountryText:selectedLang && selectedLang == 'en-US' ? r.countryEname :r.countryName
  //       })
  //       this.setState({
  //         topCountryCode:k
  //       })
  //
  //     }
  //   })
  // };
  changeDistrictyList = (data) => {
    let options = [];
    Object.keys(data).map((Kvalue) => {
      let d = {};
      let r = data[Kvalue];
      d.value = Kvalue ? Kvalue + '' : '';
      d.label = r.text;
      if (Object.keys(r.data).length) {
        d.children = this.changeDistrictyList(r.data)
      }
      options.push(d)
    });
    return options
  };
  getDistrictyList = (k, opt) => {
    let {dispatch,getDate,locale}=this.props;
    let {textv} = opt.props;

      this.setState({
      provinceCode:'', cityCode:'', districtCode:'',provinceText:'',cityText:'',districtText:'',
      countryCode: k,
      countryText: textv,
      orgAddress: textv,
      options:[],
      orgaddressk:[],
    });
      getDate(
          {
              name:'getDistrictyList',
              url:'http://192.168.3.80:10208/api/108103101',
              params:{countryId: k||'CN'},
              locale
          },
          ()=>{
              let {getDistrictyList}=this.props;
              let saveDistrictyList=getDistrictyList&&getDistrictyList.posts&&getDistrictyList.posts.json&&getDistrictyList.posts.json.json||[]

              let options=this.changeDistrictyList(saveDistrictyList);
              this.setState({
                  options,
                  orgaddressk:[],
              })
          }
      )
    // dispatch({
    //   type: 'global/getDistrictyList',
    //   payload: {countryId: k||'CN'}
    // }).then(()=>{
    //   let {saveDistrictyList}=this.props;
    //   let options=this.changeDistrictyList(saveDistrictyList);
    //   this.setState({
    //     options,
    //     orgaddressk:[],
    //   })
    // })


  };
  onChange = (v, selectedOptions) => {

    let selectedLang = this.props.locale;
    let {countryText, countryCode} = this.state;
    countryText = countryText ? countryText + '' : selectedLang && selectedLang == 'en-US' ? 'China' : '中国';
    countryCode = countryCode ? countryCode + '' : 'CN';
    let countryTextObj = {label: countryText,value:countryCode};
    selectedOptions.unshift(countryTextObj);
    this.setState({
      countryCode,
      countryText,
      orgaddressk: v,
      provinceCode: v[0] | '',
      provinceText:selectedOptions[1]?selectedOptions[1].label:'',
      cityCode: v[1] || "",
      cityText:selectedOptions[2]?selectedOptions[2].label:'',
      districtCode: v[2] || '',
      districtText:selectedOptions[3]?selectedOptions[3].label:'',
      orgAddress: selectedOptions.map(o => o.label).join('/'),
    })
  };
  render() {
    let {
      options,
      topOptions=[],
      orgaddressk,
      topOrgaddressk=[],
      countryCode,
      countryText,
      topCountryText,
      topCountryCode,
      showCascader_Address,
      isowner,
      visible
    } = this.state;
    let {
      disabled = false, isCanReset, getCountryList,isCanResetTop
    } = this.props;
      let saveCountryList=getCountryList&&getCountryList.posts&&getCountryList.posts.json&&getCountryList.posts.json.rows||[]

      // saveCountryList = saveCountryList || [];
    return (
      <div  >
        <div className={style.divHd} style={{position:'relative'}} >

          <Cascader className={style.cascaderTop} placeholder={'请选择地址'} options={topOptions} value={topOrgaddressk} onClick={this.showModal}  popupVisible={false}  allowClear={false} suffixIcon={<></>}  />
          {isCanResetTop ? <Icon className={style.clearIconTop} onClick={this.clearDateTop} type="close" disabled={disabled} ></Icon> : null}
        </div>
        <Modal
          title={'地址选择'}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          bodyStyle={{maxHeight: '600px', overflow: 'auto'}}
        >
          <div>
            <Select value={countryCode || 'CN'} disabled={disabled}  onSelect={this.getDistrictyList} style={{width: '100%'}}
                    showSearch={true}
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return option.props.children && option.props.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    }
            >
              {
                saveCountryList.map((r) => {
                  let k = r.countryId;
                  let t =  r.countryName;
                  return (
                    <Option value={k} key={k} textv={t}>{t}-{k}</Option>
                  )
                })
              }
            </Select>
            <div className={style.divHd} >
              <Cascader className={style.cascader} placeholder={'请选择'} options={options} value={orgaddressk} onChange={this.onChange} disabled={disabled}  allowClear={false} suffixIcon={<></>}  />
              {isCanReset ? <Icon className={style.clearIcon} onClick={this.clearDate} type="close" disabled={disabled} ></Icon> : null}
            </div>
          </div>
        </Modal>
      </div>

    );
  }
}
export default IntlWrap(AsyncAppHOCFN(Cascader_Address));





